module.exports = __webpack_public_path__ + "static/img/fullscreen-image_success_600.67e8f96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/fullscreen-image_success_600.png
// module id = Win7
// module chunks = 0